<script setup>
import { defineEmits, ref } from 'vue'
import SafeIcon from '@/pages/global/verifyMetaData/assets/SafeIcon.png'
import lang from '@/pages/global/verifyMetaData/lang.json'

const defaultLocal =
  navigator.language === 'zh-TW' ? 'zh-TW' : navigator.language.split('-')[0]
const local = ref(defaultLocal)
const languages = new Proxy(lang, {
  get: function (target, property) {
    if (target[property]) {
      return target[property][local.value] || target[property].en
    }
    return ''
  }
})

const emits = defineEmits(['track'])

/**
 * 跳转到app
 * 有app：打开 app；
 * 无app：跳转到官网；
 */
let timer = null
const handleVerifyNow = () => {
  const openAppUrl = `timemarkcamera://verify`

  emits('track', 'verify', { url: openAppUrl })
  window.location.href = openAppUrl

  emits('track', 'verify', { url: 'https://timemark.com' })
  timer = setTimeout(() => {
    window.location.href = 'https://timemark.com'
    clearTimeout(timer)
  }, 3000)
}
</script>

<template>
  <div class="photo-verification-wrapper">
    <div class="title">{{ languages.i_photo_verification }}</div>
    <div class="text">
      {{ languages.i_unsure_photo_was_modified_use_timemark_verify }}
    </div>
    <div class="footer">
      <div class="btn" @click="handleVerifyNow">
        <div :style="{ width: '20px', height: '20px' }">
          <img :src="SafeIcon" alt="" />
        </div>
        {{ languages.i_verify_now }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.photo-verification-wrapper {
  background: rgba(240, 245, 250, 1);
  margin-top: 20px;
  border-radius: 10px;
  padding-bottom: 30px;
  padding-top: 40px;

  .title {
    font-weight: 590;
    font-size: 16px;
    margin-bottom: 20px;
    text-align: center;
  }

  .text {
    text-align: center;
    padding: 0 36px;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }

  .footer {
    padding: 0 20px;

    .btn {
      margin-top: 30px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      border-radius: 8px;
      background: rgba(0, 112, 244, 1);
      font-weight: 590;
      font-size: 17px;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>
